import { render } from "./SubdomainLink.vue?vue&type=template&id=2d2380f8"
import script from "./SubdomainLink.vue?vue&type=script&lang=js"
export * from "./SubdomainLink.vue?vue&type=script&lang=js"
script.render = render

export default script